export enum PolicyVersion {
  v1 = 1,
  v2 = 2,
  v3 = 3,
  v4 = 4
}
